import React from 'react'
import Topsec from '../../Component/Terms/Topsec'
import Content from '../../Component/Terms/Content'
import Seo from '../../Component/Seo'

function Terms() {
  return (
    <div>
      <Seo
        title='Terms of Service | Halal Wealth'
        description='Read the Halal Wealth Terms of Service for account use, eligibility, privacy, and legal terms governing our Shariah-compliant financial platform.'
        pathname='/terms'
      />
      <Topsec/>
      <Content/>
    </div>
  )
}

export default Terms
